import { THttpService } from '@/services/HttpService';
import { setInteraction } from '.';

import { TInteractionType, TInteractionData } from './types';

export async function dispatchInteraction(
  api: THttpService,
  type: TInteractionType,
  params: TInteractionData,
): Promise<void> {
  const callBacks = {
    extra_cobranded_click_close: () => {
      setInteraction(api, 'extra_cobranded_click_close', params);
    },
    extra_cobranded_click_cta: async () => {
      await setInteraction(api, 'extra_cobranded_click_cta', params);
    },
    extra_cobranded_select_bb: async () => {
      await setInteraction(api, 'extra_cobranded_select_bb', params);
    },
    extra_cobranded_select_bradesco: async () => {
      await setInteraction(api, 'extra_cobranded_select_bradesco', params);
    },
    extra_cobranded_select_santander: async () => {
      await setInteraction(api, 'extra_cobranded_select_santander', params);
    },
  };

  await callBacks[type]();
}
